/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../item/item.ngfactory';
import * as import2 from 'ionic-angular/components/item/item';
import * as import3 from 'ionic-angular/util/form';
import * as import4 from 'ionic-angular/config/config';
import * as import5 from 'ionic-angular/components/item/item-reorder';
import * as import6 from 'ionic-angular/components/item/item-content';
import * as import7 from 'ionic-angular/components/label/label';
import * as import8 from '../radio/radio-button.ngfactory';
import * as import9 from 'ionic-angular/components/radio/radio-button';
import * as import10 from 'ionic-angular/components/radio/radio-group';
import * as import11 from 'ionic-angular/components/select/select-popover-component';
import * as import12 from '@angular/forms';
import * as import13 from 'ionic-angular/components/list/list';
import * as import14 from 'ionic-angular/platform/platform';
import * as import15 from 'ionic-angular/gestures/gesture-controller';
import * as import16 from 'ionic-angular/platform/dom-controller';
import * as import17 from '@angular/common';
import * as import18 from 'ionic-angular/navigation/nav-params';
import * as import19 from 'ionic-angular/navigation/view-controller';
const styles_SelectPopover:any[] = ([] as any[]);
export const RenderType_SelectPopover:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_SelectPopover,
  data: {}
}
);
function View_SelectPopover_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'ion-item',[[
        'class',
        'item item-block'
      ]
    ],(null as any),(null as any),(null as any),import1.View_Item_0,import1.RenderType_Item)),
    import0.ɵdid(1097728,(null as any),3,import2.Item,[
      import3.Form,
      import4.Config,
      import0.ElementRef,
      import0.Renderer,
      [
        2,
        import5.ItemReorder
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵqud(335544320,2,{contentLabel: 0}),
    import0.ɵqud(603979776,3,{_buttons: 1}),
    import0.ɵqud(603979776,4,{_icons: 1}),
    import0.ɵdid(16384,(null as any),0,import6.ItemContent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(2,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),1,2,'ion-label',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      import0.ɵdid(16384,[[
        2,
        4
      ]
    ],0,import7.Label,[
      import4.Config,
      import0.ElementRef,
      import0.Renderer,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted(2,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),4,1,'ion-radio',([] as any[]),[[
        2,
        'radio-disabled',
        (null as any)
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,12)._click($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import8.View_RadioButton_0,import8.RenderType_RadioButton)),
    import0.ɵdid(245760,(null as any),0,import9.RadioButton,[
      import3.Form,
      import4.Config,
      import0.ElementRef,
      import0.Renderer,
      [
        2,
        import2.Item
      ]
      ,
      [
        2,
        import10.RadioGroup
      ]

    ]
    ,{
      value: [
        0,
        'value'
      ]
      ,
      checked: [
        1,
        'checked'
      ]
      ,
      disabled: [
        2,
        'disabled'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted(2,['\n      ']))
  ]
  ,(ck,v) => {
    const currVal_2:any = v.context.$implicit.value;
    const currVal_3:any = v.context.$implicit.checked;
    const currVal_4:any = v.context.$implicit.disabled;
    ck(v,12,0,currVal_2,currVal_3,currVal_4);
  },(ck,v) => {
    const currVal_0:any = v.context.$implicit.text;
    ck(v,9,0,currVal_0);
    const currVal_1:any = import0.ɵnov(v,12)._disabled;
    ck(v,11,0,currVal_1);
  });
}
export function View_SelectPopover_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),11,'ion-list',[
      [
        'radio-group',
        ''
      ]
      ,
      [
        'role',
        'radiogroup'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'ngModelChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import11.SelectPopover = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.value = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(1064960,(null as any),1,import10.RadioGroup,[
      import0.Renderer,
      import0.ElementRef,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any)),
    import0.ɵqud(335544320,1,{_header: 0}),
    import0.ɵprd(1024,(null as any),import12.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import10.RadioGroup]),
    import0.ɵdid(671744,(null as any),0,import12.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import12.NG_VALUE_ACCESSOR
      ]

    ]
      ,{model: [
        0,
        'model'
      ]
    },{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import12.NgControl,(null as any),[import12.NgModel]),
    import0.ɵdid(16384,(null as any),0,import12.NgControlStatus,[import12.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import13.List,[
      import4.Config,
      import0.ElementRef,
      import0.Renderer,
      import14.Platform,
      import15.GestureController,
      import16.DomController
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n      '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SelectPopover_1)),
    import0.ɵdid(802816,(null as any),0,import17.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n  ']))
  ]
  ,(ck,v) => {
    var co:import11.SelectPopover = v.component;
    const currVal_7:any = co.value;
    ck(v,5,0,currVal_7);
    const currVal_8:any = co.options;
    ck(v,11,0,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,7).ngClassUntouched;
    const currVal_1:any = import0.ɵnov(v,7).ngClassTouched;
    const currVal_2:any = import0.ɵnov(v,7).ngClassPristine;
    const currVal_3:any = import0.ɵnov(v,7).ngClassDirty;
    const currVal_4:any = import0.ɵnov(v,7).ngClassValid;
    const currVal_5:any = import0.ɵnov(v,7).ngClassInvalid;
    const currVal_6:any = import0.ɵnov(v,7).ngClassPending;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_SelectPopover_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ng-component',([] as any[]),(null as any),(null as any),(null as any),View_SelectPopover_0,RenderType_SelectPopover)),
    import0.ɵdid(114688,(null as any),0,import11.SelectPopover,[
      import18.NavParams,
      import19.ViewController
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const SelectPopoverNgFactory:import0.ComponentFactory<import11.SelectPopover> = import0.ɵccf('ng-component',import11.SelectPopover,View_SelectPopover_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./node_modules/ionic-angular/components/select/select-popover-component.ngfactory.ts